import React, { Component } from 'react';
import './App.css';
import HeroUnit from './components/HeroUnit';
import ServiceList from './components/ServiceList';
import Tagline from './components/Tagline';
import Partners from './components/Partners';
import Footer from './components/Footer';

class App extends Component {
  
  get __renderYear(){
    const today = new Date();

    return today.getFullYear();
  }

  render() {
    return (
      <div className="App">
        <HeroUnit 
          title="CMSLA, LLC"
          tagline="Entitlements &bull; Alcohol Licensing &bull; Development Consulting &bull; Radius Maps"
        >
          <Tagline text="We find innovative solutions to your complex business challenges." />
        </HeroUnit>
        <ServiceList />
        <Partners />
        <Footer year={this.__renderYear} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js